/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { connect } from "react-redux";
import { Button } from "../../ui/button";
import { bindActionCreators } from "redux";
import PaymentHistoryTable from "./paymentHistoryTable";
import {
  getPaymentHistorytableList, setInitialPaymentHistoryPage, setPaymentHistoryRecordShow, setPaymentHistoryItems, setIsHistoryVisible,
  setRecordsShow,
  setSnackbar,
  getPaymentHistorytable,
} from "./paymentHistoryTableSlice";
import {
  formatMoney,
  getBrowserDate,
  Currency,
  cleanObject,
  getIsOssino,
  getConvertedAmountWithCurrency,
} from "../../sharedfiles/helper";
import { getFinancials } from "../primaryplayer/PrimaryPlayerSlice";
import { exportPDFC } from "../../sharedfiles/pdfExport";
import Vpagination from "../../sharedfiles/Vpagination";
import Skelton from "../Common/skeleton/Skeleton";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../ui/select";
import { Label } from "../../ui/label";
import ManualDialog from "./ManualDialog";
import { setIntervalStopper } from "../AppSlice";
import { manualDropdown, paymentHeaders } from "../Common/data/mapData";
import { COMMON_CONSTANTS, KYC_CONSTANTS, PYMENTHISTORY_CONSTANTS } from "../../sharedfiles/Constants";
import { getPaymentSearchtableList } from "../PaymentSearch/paymentSearchSlice"
class PaymentHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentFilterData: [],
      payment: "",
      paymentType: "ALL",
      adjustmentType: "",
      amount: 0,
      comments: "",
      description: "",
      data: [],
      activePage: 1,
      itemsPerPage: 25,
      recordsFrom: "1",
      recordsTo: "25",
      totalPages: "",
      isValid: true,
      document: "",
      modelMoneyError: false,
      condition: false,
      payloadData: {
        paymentType: "",
        userId: localStorage.getItem("userId"),
        status: "",
      },
      status: "ALL",
      statusError: false,
      netWithdrawal: this.props.financialData.playerSummaryVw?.netWithdrawal
        ? this.props.financialData.playerSummaryVw?.netWithdrawal
        : 0,
      netDeposit: this.props.balanceData.playerSummaryVw?.deposit
        ? this.props.balanceData?.playerSummaryVw.deposit
        : 0,
      balanceAmount: 0,
      customerID: "",
      csvData: [],
      pdfBody: [],
      option: "ONLINE",
      headers: paymentHeaders,
    };
    this.onChangePaymentHistory = this.onChangePaymentHistory.bind(this);
    this.myDocument = this.myDocument.bind(this);
    this.exportPDF = this.exportPDF.bind(this);
    this.onSearchRecord = this.onSearchRecord.bind(this);
    this.resetButton = this.resetButton.bind(this);
    this.onChangeStatus = this.onChangeStatus.bind(this);
    // this.onSubmit = this.onSubmit.bind(this);
    this.callApi = this.callApi.bind(this);
    this.updateTableToDocs = this.updateTableToDocs.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
    this.onChangeOption = this.onChangeOption.bind(this);
  }

  callApi(pageNumber, itemsPerPage, data) {
    this.props.dispatch(setIsHistoryVisible(false));
    this.props.dispatch(
      getFinancials({ user_id: localStorage.getItem("userId") })
    );
    this.props.dispatch(
      getPaymentHistorytable(
        pageNumber - 1,
        itemsPerPage,
        data
        // { id: localStorage.getItem("userId") },
      )
    );
  }

  headers = [
    [
      "Transaction Id",
      "Created On",
      "Updated On",
      "Created By",
      `Amount ${Currency()}`,
      ...(getIsOssino() ? ["Amount (USD)"] : []),
      "State",
      `TDS Amount ${Currency()}`,
      ...(getIsOssino() ? ["TDS Amount (USD)"] : []),
      "TDS Percentage",
      "Method",
      "Payment Type",
      "Payment Method",
      "Payment Description",
      "Bank Name",
      "Reference ID",
    ],
  ];

  myDocument(e) {
    this.setState({ document: e.target.value });
  }

  updateTableToDocs() {
    setTimeout(() => {
      const permission = this.props.tdsPermission
      const data =
        this.props.paymentHistoryUserData.data &&
        this.props.paymentHistoryUserData.data &&
        Array.isArray(this.props.paymentHistoryUserData.data) &&
        this.props.paymentHistoryUserData.data.map((elt) => [
          elt.id,
          getBrowserDate(elt.createdDate),
          getBrowserDate(elt.updatedDate),
          elt.addedBy,
          elt.updatedByUserName || '-',
          getConvertedAmountWithCurrency(elt.amount, elt.currencyCode || elt.currency, elt.baseCurrencyRate),
          ...(getIsOssino ? [elt.amountUsd ?? "-"] : []),
          elt.status,
          elt.tdsAmount ? getConvertedAmountWithCurrency(elt.tdsAmount, elt.currencyCode || elt.currency, elt.baseCurrencyRate) : "0",
          ...(getIsOssino() ? [elt.tdsAmountUsd ?? "-"] : []),
          elt.tdsPercentage,
          elt.paymentType,
          elt.paymentMethodType,
          elt.modePaymentClient,
          elt.paymentDesc,
          elt.bankName,
          elt.transactionRef,
        ]);
      const filterData = !permission && data?.map((record) => record?.filter((v, ind) => ind !== 6 && ind !== 7))
      const opData = permission ? data : filterData;
      const csvData =
        data?.length > 0
          ? [this.state.headers, ...opData]
          : [this.state.headers, [["No data found"]]];
      this.setState({ pdfBody: opData });
      this.setState({ csvData: csvData });
    }, 500);
  }

  exportPDF() {
    const title = "Payment History Report";

    const styles = {
      2: {
        halign: "right",
        valign: "middle",
      },
    };
    exportPDFC(title, [this.state.headers], this.state.pdfBody, styles);
  }
  resetState() {
    this.setState({
      paymentType: "ALL",
      status: "ALL",
      statusError: false,
      option: "ONLINE",
      payloadData: {
        paymentType: "ALL",
        userId: localStorage.getItem("userId"),
        status: "ALL",
      },
    });
  }

  resetCall(data) {
    this.props.dispatch(setIsHistoryVisible(false));
    this.props.dispatch(setInitialPaymentHistoryPage(1));
    this.props.dispatch(setPaymentHistoryItems(25));
    this.props.dispatch(setPaymentHistoryRecordShow([1, 25]));
    this.props.dispatch(getPaymentHistorytable(0, 25, data));
  }

  resetButton() {
    const id = window.location.pathname.split("/")[2];
    const data = {
      paymentType: this.state.paymentType,
      paymentApprovalType: this.state.option,
      userId: id,
      status: this.state.status,
    };
    this.resetState();
    this.resetCall(data);
  }

  onChangePaymentHistory(e) {
    this.setState({ paymentType: e.target.value });
    //  this.setState({ condition: false });
    if (e.target.value === "ALL") {
      this.setState({ adjustmentType: "" });
    }
  }

  onChangeOption(e) {
    this.setState({ option: e.target.value });
    if (e.target.value === "ONLINE") {
      this.setState({ adjustmentType: "" });

    }
  }
  onChangeStatus(e) {
    if (e.target.value.length > 0) {
      this.setState({ statusError: false });
    }

    this.setState({ status: e.target.value });
  }
  onChangeAdjustment(e) {
    this.setState({ adjustmentType: e.target.value });
  }
  // searchRecords = () => {
  //   this.setState({
  //     paymentFilterData: { paymentType: this.state.paymentType },
  //   });
  // };

  searchData() {
    return {
      paymentType: this.state.paymentType,
      userId: localStorage.getItem("userId"),
      status: this.state.status,
      paymentApprovalType: this.state.option,
      manualAdjustment: this.state.adjustmentType,
    }
  }

  onSearchRecord(e) {
    e.preventDefault();
    const data = cleanObject(this.searchData());
    this.setState({ payloadData: data });
    if (this.state.paymentType !== "" && this.state.status !== "") {
      this.props.dispatch(setIsHistoryVisible(false));
      if (this.props.initialPaymentHistoryPage == 1) {
        this.callApi(
          this.props.initialPaymentHistoryPage,
          this.props.paymentHistoryItems,
          data
        );
        this.props.dispatch(setInitialPaymentHistoryPage(1))
        this.props.dispatch(setPaymentHistoryItems(25))
        this.props.dispatch(setPaymentHistoryRecordShow([1, 25]))
      }
      if (this.props.initialPaymentHistoryPage > 1) {
        this.resetCall(data);
      }
      // this.props.dispatch(
      //   getPaymentHistorytableList(
      //     this.props.initialPaymentHistoryPage - 1,
      //     this.props.paymentHistoryItems,
      //     payloadData,
      //     this.updateTableToDocs
      //   )
      // );
      // this.setState({ paymentType: "ALL", status: "" });
    }
    if (this.state.status === "") {
      this.setState({ statusError: true });
    } else {
      this.setState({ statusError: false });
    }
  }

  makemanual = () => {
    this.props.dispatch(setSnackbar(true));
    this.props.dispatch(setIntervalStopper(true));
  };

  DialogClose = () => {
    this.props.dispatch(setSnackbar(false));
    this.props.dispatch(setIntervalStopper(false));
    this.setState({
      amount: "",
      comments: "",
      adjustmentType: "",
      modelMoneyError: false,
      payment: "",
      isValid: true,
      offlinePayment: true,
    });
  };

  onKeyUp(event) {
    if (event.charCode === 13) {
      this.onSubmit(event);
    }
  }
  resetData() {
    this.props.dispatch(setInitialPaymentHistoryPage(1))
    this.props.dispatch(setPaymentHistoryItems(25))
    this.props.dispatch(setPaymentHistoryRecordShow([1, 25]))
  }
  componentDidMount() {
    const id = window.location.pathname.split("/")[2];
    const searchedData = {
      paymentType: this.state.paymentType,
      paymentApprovalType: this.state.option,
      userId: id,
      status: this.state.status,
    };
    if (!this.props.tdsPermission) {
      const v = this.state.headers.filter((key) => key !== "TDS Percentage" && key !== `TDS Amount ${Currency()}`)
      this.setState({ headers: v })
    }
    this.setState({ customerID: id });
    this.setState({ payloadData: searchedData });
    // this.callApi(1, 25, searchedData)
    this.resetData();
    this.props.dispatch(getPaymentHistorytable(0, 25, searchedData));
    this.props.dispatch(setPaymentHistoryRecordShow([1, 25]))
    this.updateTableToDocs(this.state.paymentHistoryUserData);
    this.props.dispatch(setIsHistoryVisible(true));

  }
  componentDidUpdate(prevProps) {
    if (prevProps.paymentHistoryUserData !== this.props.paymentHistoryUserData) {
      this.updateTableToDocs(this.props.paymentHistoryUserData);
    }
    const id = window.location.pathname.split("/")[2];
    if (prevProps.userId !== id) {
      this.resetState();
      this.setState({ customerID: id });
      // const newPayload = { ...cleanObject(this.searchData()), id: id }
      this.callApi(1, 25, { userId: id })
    }
  }
  render() {
    const errorStyles = {
      color: "red",
      marginTop: "-13px",
      marginBottom: "20px",
    };

    const isPresent =
      Object.keys(this.props.userPagePermissions).length > 0 &&
      this.props.userPagePermissions.find(
        (item) => item.permissionName == "HIDE_MANUAL_ADJUSTMENT"
      );
    return (
      <>
        {
          this.props.snackbar && (
            <Dialog open={this.props.snackbar} onOpenChange={(open) => !open && this.DialogClose()}>
              <DialogContent className="sm:max-w-[425px]">
                <DialogHeader>
                  <DialogTitle>Balance Manual Adjustment</DialogTitle>
                </DialogHeader>
                <ManualDialog
                  availableAmount={
                    this.props?.financialData?.playerSummaryVw?.withdrawls
                  }
                  status={this.state.status}
                  DialogClose={this.DialogClose}
                  errorStyles={errorStyles}
                  depositBalance={
                    this.props?.balanceData?.playerSummaryVw?.deposit
                  }
                  onSubmit={this.onSubmit}
                />
              </DialogContent>
            </Dialog>
          )
        }

        <div className="space-y-6">
          {/* Financial Summary Card */}
          <div className="rounded-lg border bg-card shadow-sm">
            <div className="p-6 border-b">
              <h3 className="text-lg font-semibold text-foreground">Financial Summary</h3>
              <p className="text-sm text-muted-foreground mt-1">Overview of player financial data</p>
            </div>
            <div className="p-6">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {/* Cash Balance Card */}
                <div className="rounded-lg border bg-gradient-to-br from-blue-50/50 to-blue-100/30 dark:from-blue-950/20 dark:to-blue-900/10 border-blue-200 dark:border-blue-800 p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <div className="h-2 w-2 rounded-full bg-blue-500"></div>
                    <span className="text-xs font-medium text-muted-foreground">{PYMENTHISTORY_CONSTANTS.header_cashBalance}</span>
                  </div>
                  <span className="text-2xl font-bold text-blue-700 dark:text-blue-400">
                    {Currency()}{" "}
                    {formatMoney(
                      this.props.showPayments &&
                        Object.keys(this.props?.financialData).length > 0
                        ? this.props?.financialData?.playerSummaryVw?.deposit +
                        this.props?.financialData.playerSummaryVw?.withdrawls
                        : 0
                    )}
                  </span>
                </div>

                {/* Payment Status Card */}
                <div className="rounded-lg border bg-gradient-to-br from-purple-50/50 to-purple-100/30 dark:from-purple-950/20 dark:to-purple-900/10 border-purple-200 dark:border-purple-800 p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <div className="h-2 w-2 rounded-full bg-purple-500"></div>
                    <span className="text-xs font-medium text-muted-foreground">{PYMENTHISTORY_CONSTANTS.header_payments}</span>
                  </div>
                  <span
                    className={
                      this.props.playerData != undefined &&
                        this.props.playerData?.userOtherInfo?.paymentEnabled === true
                        ? "inline-flex items-center px-3 py-1.5 rounded-full text-sm font-semibold bg-green-100 text-green-800 dark:bg-green-950 dark:text-green-400"
                        : "inline-flex items-center px-3 py-1.5 rounded-full text-sm font-semibold bg-red-100 text-red-800 dark:bg-red-950 dark:text-red-400"
                    }
                  >
                    {this.props.playerData != undefined &&
                      this.props.playerData?.userOtherInfo?.paymentEnabled === true
                      ? "ENABLED"
                      : "DISABLED"}
                  </span>
                </div>

                {/* Deposit Limits Card */}
                <div className="rounded-lg border bg-gradient-to-br from-amber-50/50 to-amber-100/30 dark:from-amber-950/20 dark:to-amber-900/10 border-amber-200 dark:border-amber-800 p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <div className="h-2 w-2 rounded-full bg-amber-500"></div>
                    <span className="text-xs font-medium text-muted-foreground">{PYMENTHISTORY_CONSTANTS.header_depoLimits}</span>
                  </div>
                  <span className="text-2xl font-bold text-amber-700 dark:text-amber-400">
                    {this.props?.userinfo?.userLimit
                      ? this.props.userinfo?.userLimit?.depositLimit
                      : 0}
                  </span>
                </div>

                {/* Max Limit Card */}
                <div className="rounded-lg border bg-gradient-to-br from-green-50/50 to-green-100/30 dark:from-green-950/20 dark:to-green-900/10 border-green-200 dark:border-green-800 p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <div className="h-2 w-2 rounded-full bg-green-500"></div>
                    <span className="text-xs font-medium text-muted-foreground">{PYMENTHISTORY_CONSTANTS.header_max}</span>
                  </div>
                  <span className="text-2xl font-bold text-green-700 dark:text-green-400">
                    {this.props.userinfo?.userLimit
                      ? this.props.userinfo?.userLimit?.depositLimit
                      : 0}
                  </span>
                </div>

                {/* Credit Total Card */}
                <div className="rounded-lg border bg-gradient-to-br from-cyan-50/50 to-cyan-100/30 dark:from-cyan-950/20 dark:to-cyan-900/10 border-cyan-200 dark:border-cyan-800 p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <div className="h-2 w-2 rounded-full bg-cyan-500"></div>
                    <span className="text-xs font-medium text-muted-foreground">{PYMENTHISTORY_CONSTANTS.header_creditTotal}</span>
                  </div>
                  <span className="text-2xl font-bold text-cyan-700 dark:text-cyan-400">
                    {Currency()}{" "}
                    {formatMoney(
                      this.props.showPayments &&
                        Object.keys(this.props.financialData).length > 0 &&
                        this.props.financialData?.playerSummaryVw?.withdrawls
                        ? this.props.financialData?.playerSummaryVw?.withdrawls
                        : 0
                    )}
                  </span>
                </div>

                {/* Debit Total Card */}
                <div className="rounded-lg border bg-gradient-to-br from-rose-50/50 to-rose-100/30 dark:from-rose-950/20 dark:to-rose-900/10 border-rose-200 dark:border-rose-800 p-4">
                  <div className="flex items-center gap-2 mb-2">
                    <div className="h-2 w-2 rounded-full bg-rose-500"></div>
                    <span className="text-xs font-medium text-muted-foreground">{PYMENTHISTORY_CONSTANTS.header_debitTotal}</span>
                  </div>
                  <span className="text-2xl font-bold text-rose-700 dark:text-rose-400">
                    {Currency()}{" "}
                    {formatMoney(
                      this.props.showPayments &&
                        Object.keys(this.props.financialData).length > 0 &&
                        this.props.financialData?.playerSummaryVw?.netWithdrawal
                        ? this.props.financialData?.playerSummaryVw?.netWithdrawal
                        : 0
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Filters Card */}
          <div className="rounded-lg border bg-card shadow-sm p-6">
            <h3 className="text-base font-semibold mb-4">Search Filters</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
              <div className="space-y-2">
                <Label htmlFor="option" className="text-sm font-medium">Approval Type</Label>
                <Select value={this.state.option} onValueChange={(value) => this.onChangeOption({ target: { value, id: 'option' } })}>
                  <SelectTrigger id="option">
                    <SelectValue placeholder="Select approval type" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="ONLINE">{PYMENTHISTORY_CONSTANTS.ddlOpt_auto}</SelectItem>
                    <SelectItem value="MANUAL">{PYMENTHISTORY_CONSTANTS.ddlOpt_manual}</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              <div className="space-y-2">
                <Label htmlFor="paymentType" className="text-sm font-medium">Payment Type</Label>
                <Select value={this.state.paymentType} onValueChange={(value) => this.onChangePaymentHistory({ target: { value, id: 'paymentType' } })}>
                  <SelectTrigger id="paymentType">
                    <SelectValue placeholder="Select payment type" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="ALL">{PYMENTHISTORY_CONSTANTS.ddlOpt_all}</SelectItem>
                    <SelectItem value="WITHDRAW">{PYMENTHISTORY_CONSTANTS.ddlOpt_withDrwal}</SelectItem>
                    <SelectItem value="DEPOSIT">{PYMENTHISTORY_CONSTANTS.ddlOpt_deposit}</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              {this.state.option !== "ONLINE" && this.state.paymentType !== "ALL" && (
                <div className="space-y-2">
                  <Label htmlFor="adjustmentType" className="text-sm font-medium">Adjustment Type</Label>
                  <Select value={this.state.adjustmentType || undefined} onValueChange={(value) => this.onChangeAdjustment({ target: { value, id: 'adjustmentType', name: 'adjustmentType' } })}>
                    <SelectTrigger id="adjustmentType">
                      <SelectValue placeholder={COMMON_CONSTANTS.ddlOpt_select} />
                    </SelectTrigger>
                    <SelectContent>
                      {manualDropdown.map((item, index) => {
                        return this.state.paymentType === "DEPOSIT" && item.isDeposit ? (
                          <SelectItem key={index} value={item.value}>{item.name}</SelectItem>
                        ) : (
                          this.state.paymentType === "WITHDRAW" &&
                          !item.isDeposit && <SelectItem key={index} value={item.value}>{item.name}</SelectItem>
                        );
                      })}
                    </SelectContent>
                  </Select>
                </div>
              )}

              <div className="space-y-2">
                <Label htmlFor="paymentstatus" className="text-sm font-medium">Status</Label>
                <Select value={this.state.status} onValueChange={(value) => this.onChangeStatus({ target: { value, id: 'paymentstatus' } })}>
                  <SelectTrigger id="paymentstatus" className={this.state.statusError ? "border-red-500" : ""}>
                    <SelectValue placeholder={KYC_CONSTANTS.header_status} />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="ALL">{PYMENTHISTORY_CONSTANTS.ddlOpt_all}</SelectItem>
                    <SelectItem value="INIT">{PYMENTHISTORY_CONSTANTS.ddlOpt_init}</SelectItem>
                    <SelectItem value="APPROVED">{PYMENTHISTORY_CONSTANTS.ddlOpt_approved}</SelectItem>
                    <SelectItem value="CONFIRMED">{PYMENTHISTORY_CONSTANTS.ddlOpt_confirmed}</SelectItem>
                    <SelectItem value="DECLINED">{PYMENTHISTORY_CONSTANTS.ddlOpt_decline}</SelectItem>
                    <SelectItem value="CANCELLED">{PYMENTHISTORY_CONSTANTS.ddlOpt_cancelled}</SelectItem>
                    <SelectItem value="VERIFIED">{PYMENTHISTORY_CONSTANTS.ddlOpt_verified}</SelectItem>
                    <SelectItem value="HOLD">{PYMENTHISTORY_CONSTANTS.ddlOpt_hold}</SelectItem>
                  </SelectContent>
                </Select>
                {this.state.statusError && (
                  <div className="text-sm text-red-500 mt-1">Please select status</div>
                )}
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex items-center gap-3 pt-4 border-t mt-6">
              <Button
                variant="default"
                type="button"
                onClick={this.onSearchRecord}
                id="paymentsearch"
              >
                {COMMON_CONSTANTS.searchBtn}
              </Button>
              <Button
                variant="outline"
                type="button"
                id="paymentreset"
                onClick={this.resetButton}
              >
                {COMMON_CONSTANTS.resetBtn}
              </Button>
              {!isPresent && (
                <Button
                  variant="default"
                  type="button"
                  id="makemanualadjust"
                  onClick={() => this.makemanual()}
                  disabled={this.props.viewOnlyuser}
                >
                  {PYMENTHISTORY_CONSTANTS.manualAdjustmentBtn}
                </Button>
              )}
            </div>
          </div>

          {/* Results Section */}
          <div className="space-y-4" id="result">
            <Vpagination
              data={this.props.paymentHistoryUserData.data}
              totalRecords={this.props.paymentHistoryUserData.totalRecords}
              paginationFirstValue={this.props.initialPaymentHistoryPage}
              paginationSecondValue={this.props.paymentHistoryItems}
              setPaginationFirstValue={setInitialPaymentHistoryPage}
              setPaginationSecondValue={setPaymentHistoryItems}
              recordsShow={this.props.paymentHistoryRecordShow}
              setRecordsShow={setPaymentHistoryRecordShow}
              isVisible={this.props.isHistoryVisible}
              setIsVisible={setIsHistoryVisible}
              csvData={this.state.csvData}
              exportPDF={this.exportPDF}
              callApi={this.callApi}
              csvFileName={"PaymentHistory"}
              payloadData={this.state.payloadData}
            />
            <div className="rounded-lg border bg-card shadow-sm overflow-hidden">
              {!this.props.isHistoryVisible ? (
                <Skelton />
              ) : (
                <PaymentHistoryTable
                  data={
                    this.state.condition
                      ? this.state.paymentFilterData
                      : this.props.paymentHistoryUserData.data
                  }
                  tdsExist={this.props.tdsPermission}
                  enableDownload
                  pdfTitle="Payment Event Details"
                  fileName="payment-event-details"
                />
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}
function mapStateToProps(state) {
  return {
    displayValue: state.sidebar.displayValue,
    paymentData: state.paymentHistorySlice.paymentData,
    initialPaymentHistoryPage: state.paymentHistorySlice.initialPaymentHistoryPage,
    paymentHistoryItems: state.paymentHistorySlice.paymentHistoryItems,
    snackbar: state.paymentHistorySlice.snackbar,
    paymentHistoryRecordShow: state.paymentHistorySlice.paymentHistoryRecordShow,
    userId: state.playersearch.userId,
    addmakeid: state.paymentHistorySlice.addmakeid,
    paymentData: state.paymentHistorySlice.paymentData,
    userinfo: state.paymentHistorySlice.userinfo,
    financialData: state.primaryplayer.financialData,
    balanceData: state.primaryplayer.balanceData,
    isHistoryVisible: state.paymentHistorySlice.isHistoryVisible,
    showPayments: state.paymentHistorySlice.showPayments,
    playerData: state.paymentHistorySlice.playerData,
    playerData: state.generaldetail?.playerData,
    userPagePermissions: state.dashboard.userPagePermissions,
    tdsPermission: state.dashboard.tdsPermission,
    paymentHistoryUserData: state.paymentHistorySlice.paymentHistoryUserData,
    viewOnlyuser: state.dashboard.viewOnlyuser,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    actions: bindActionCreators({}, dispatch),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(PaymentHistory);